<template
  ><div>
    <breakdown
      v-for="section in sections"
      :key="section"
      :id="section"
      :breakdown="scoreReport[section]"
      :name="section"
    /></div
></template>

<script>
import Constants from "../../../services/Constants";
import Breakdown from "../Breakdown";
export default {
  name: "ActScores",
  components: { Breakdown },
  props: {
    scoreReport: {
      type: Object,
      default: null
    }
  },
  computed: {
    sections() {
      return Constants.EXAM_SECTIONS.ACT.SECTIONS;
    }
  }
};
</script>

<style scoped></style>
